import createReducer from './_createReducerHelper';

export const LOGIN_SUCCESS_MSG = 'login-form/LOGIN_SUCCESS_MSG';
export const LOGIN_ERROR_MSG = 'login-form/LOGIN_ERROR_MSG';
export const LOGIN_IMAGE = 'login-form/LOGIN_IMAGE';

const initialState = {
  message: null,
  messageType: null,
  loginImage: null,
};

/** ********************************************
 * reducer
 ******************************************** */

export default createReducer(initialState, {
  [LOGIN_IMAGE]: (state, { payload }) => ({ ...state, loginImage: payload }),
  [LOGIN_SUCCESS_MSG]: (state, { payload }) => ({ message: payload, messageType: 'success' }),
  [LOGIN_ERROR_MSG]: (state, { payload }) => ({ message: payload, messageType: 'error' }),
});

/** ********************************************
 * actions
 ******************************************** */

/**
 *
 * @param loginImage
 * @return {{type: string, payload: *}}
 */
export const setLoginImage = (loginImage) => ({
  type: LOGIN_IMAGE,
  payload: loginImage,
});

/**
 *
 * @param payload
 * @return {{type, payload: *}}
 */
export const loginFormSuccessMsg = (payload) => ({
  type: LOGIN_SUCCESS_MSG,
  payload,
});

/**
 *
 * @param payload
 * @return {{type, payload: *}}
 */
export const loginFormErrorMsg = (payload) => ({
  type: LOGIN_ERROR_MSG,
  payload,
});

/** ********************************************
 * selectors
 ******************************************** */

export const selectLoginFormMessage = (state) => ({
  message: state.loginForm.message,
  type: state.loginForm.messageType,
});
export const selectLoginImage = (state) => state.loginForm.loginImage;
